// 통합앱(Tauri) 창의 **웹뷰 기본 오른쪽 클릭 메뉴**를 막는다(2026-09-27 사용자 요청).
//
// macOS WKWebView 는 "찾아보기·번역·Google 검색·복사·공유·말하기·서비스…", Windows WebView2 는 "뒤로·새로 고침·인쇄·검사…" 같은
// 브라우저용 메뉴를 띄운다 — 앱에는 맞지 않고, "검사" 처럼 앱 내부를 여는 항목도 있다. 사용자 결정: **앱 전체, 입력칸 포함**
// (입력칸 붙여넣기는 Ctrl/Cmd+V). 브라우저 뷰어는 건드리지 않는다(브라우저 메뉴는 사용자의 것이다).
//
// 캡처 단계에서 기본 동작만 막는다 → 우리 화면이 직접 만든 오른쪽 클릭 처리(원격 화면에 오른쪽 버튼 보내기 등)는 그대로 돈다.

/** Tauri 웹뷰 안인가 — 모든 창(메인·세션·채팅·그리기)에 공통으로 있는 표식으로 본다(`__RS_SHELL__` 은 창마다 주입 여부가 다르다). */
function inTauri(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

let installed = false;

/** 각 창 진입점(main.tsx)에서 한 번 부른다. 브라우저에서는 아무 일도 하지 않는다. */
export function blockNativeContextMenu(): void {
  if (installed || !inTauri()) return;
  installed = true;
  window.addEventListener('contextmenu', (e) => e.preventDefault(), { capture: true });
}
